import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import Home from "@/pages/Home";
import Reports from "@/pages/Reports";
import MapPage from "@/pages/MapPage";
import Customers from "@/pages/Customers";
import Leads from "@/pages/Leads";
import ClientDetail from "@/pages/ClientDetail";
import Packages from "@/pages/Packages";
import Team from "@/pages/Team";
import Jobs from "@/pages/Jobs";
import Settings from "@/pages/Settings";
import SmsNotifications from "@/pages/SmsNotifications";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground font-serif text-2xl italic">
        Preparing your space…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                element={
                  <Protected>
                    <Layout />
                  </Protected>
                }
              >
                <Route path="/" element={<Home />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/clients/:id" element={<ClientDetail />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/team" element={<Team />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/settings/sms" element={<SmsNotifications />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
          <svg width="0" height="0" className="absolute" aria-hidden="true">
            <defs>
              <linearGradient id="brand-grad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="24" y2="24">
                <stop offset="0%" stopColor="hsl(340 92% 56%)" />
                <stop offset="100%" stopColor="hsl(270 90% 52%)" />
              </linearGradient>
            </defs>
          </svg>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
